export const SESSION_FLASH_KEY = 'mensis_session_flash';
